/**
 * What a student hears when the plan ledger refuses a paid action (#4668,
 * founder 2026-10-18: "season pass covers everything without any mention of
 * any usage or credits").
 *
 * A FREE account hears the Season Pass offer (product invariant 3: every
 * refusal carries the way out). A PAID account can never be told to buy
 * what it owns, and never hears a figure: it hears fair use and a person.
 * One definition, imported by every refusal surface, so the wording cannot
 * drift (review 2026-10-18: EssayHelpPage shipped the pricing CTA to a Pass
 * holder because its 402 path was the one that never reached the modal).
 */
export const SUPPORT_EMAIL = 'support@stratiaadmissions.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

/** The paid refusal, as a sentence a text-only surface can show whole. */
export const PAID_REFUSAL_LINE = `We couldn't run that one right now. Your Season Pass covers it; write to ${SUPPORT_EMAIL} and we'll sort it out.`;

/** The paid refusal for a surface with its own support button. */
export const PAID_REFUSAL_SHORT = "We couldn't run that one right now. Your Season Pass covers it.";

/**
 * Paid means the ledger SAID so: `isFreeTier === false`. A provider that
 * does not say (undefined, no provider mounted) reads as free, the side
 * whose refusal is an offer and never a false "you own this" (the same
 * default CreditGate takes).
 */
// A trial account (#4703) holds the Pass tier but owns nothing yet: its
// refusals carry the Season Pass offer, never "your Pass covers it".
export const isPaidAccount = (payment) => !!payment && payment.isFreeTier === false && !payment.isTrial;
